import { render, staticRenderFns } from "./WComment.yaml?vue&type=template&id=098005f9&component"
import script from "./WComment.yaml?vue&type=script&lang=ts&component"
export * from "./WComment.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports